import React, { useState, useEffect, useCallback } from 'react';
import unitService from '../../../services/unitService';

const UnitsTab = () => {
  const [units, setUnits] = useState([]);
  const [newUnit, setNewUnit] = useState({ nazwa: '', skrot: '', wzorce_regex: '', aktywny: true });
  const [editingUnit, setEditingUnit] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadUnits = useCallback(async () => {
    try {
      setLoading(true);
      const data = await unitService.getUnits();
      setUnits(data || []);
    } catch (error) {
      console.error('Błąd ładowania jednostek:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadUnits();
  }, [loadUnits]);

  const resetForm = () => {
    setNewUnit({ nazwa: '', skrot: '', wzorce_regex: '', aktywny: true });
  };

  const addUnit = async () => {
    if (!newUnit.nazwa || !newUnit.skrot) return;
    try {
      await unitService.addUnit(newUnit);
      loadUnits();
      resetForm();
    } catch (error) {
      console.error('Błąd dodawania jednostki:', error);
    }
  };

  const updateUnit = async () => {
    if (!editingUnit) return;
    try {
      await unitService.updateUnit(editingUnit.id, editingUnit);
      loadUnits();
      setEditingUnit(null);
    } catch (error) {
      console.error('Błąd aktualizacji jednostki:', error);
    }
  };

  const deleteUnit = async (id) => {
    if (!window.confirm('Czy na pewno chcesz usunąć tę jednostkę miary?')) return;
    try {
      await unitService.deleteUnit(id);
      loadUnits();
    } catch (error) {
      console.error('Błąd usuwania jednostki:', error);
    }
  };

  const startEditUnit = (unit) => {
    setEditingUnit({ ...unit });
  };

  const cancelEditUnit = () => {
    setEditingUnit(null);
  };

  return (
    <div className="admin-table-wrap" style={{ maxWidth: '800px' }}>
      <style>{`
        @media (max-width: 600px) {
          .units-form-grid { grid-template-columns: 1fr !important; }
          .units-edit-row { flex-wrap: wrap !important; }
          .units-edit-row input { flex: 1 1 100px !important; min-width: 0 !important; width: auto !important; }
          .units-list-row { flex-direction: column !important; align-items: stretch !important; gap: 0.4rem !important; }
        }
        @media (min-width: 601px) and (max-width: 900px) {
          .units-form-grid { grid-template-columns: 1fr 80px 1fr !important; }
          .units-form-grid > label, .units-form-grid > button { grid-column: span 1; }
        }
      `}</style>
      {/* Formularz dodawania */}
      <div style={{
        backgroundColor: 'var(--card-bg)',
        border: '1px solid var(--border)',
        borderRadius: '5px',
        marginBottom: '1rem',
        padding: '0.75rem',
        background: 'var(--bg)'
      }}>
        <h6 style={{ margin: '0 0 0.75rem 0', fontWeight: '600', color: 'var(--text-secondary)', fontSize: '12px' }}>
          ➕ Nowa Jednostka Miary
        </h6>
        <div className="units-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 80px 1fr auto auto', gap: '0.5rem', alignItems: 'end' }}>
          <div>
            <label style={{ display: 'block', fontSize: '11px', fontWeight: '500', color: 'var(--text-muted)', marginBottom: '2px' }}>Nazwa *</label>
            <input type="text" value={newUnit.nazwa} onChange={(e) => setNewUnit({ ...newUnit, nazwa: e.target.value })}
              style={{ width: '100%', padding: '5px 8px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '12px', height: '28px' }}
              placeholder="np. kapsułki" />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '11px', fontWeight: '500', color: 'var(--text-muted)', marginBottom: '2px' }}>Skrót *</label>
            <input type="text" value={newUnit.skrot} onChange={(e) => setNewUnit({ ...newUnit, skrot: e.target.value })}
              style={{ width: '100%', padding: '5px 8px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '12px', height: '28px' }}
              placeholder="kaps" />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '11px', fontWeight: '500', color: 'var(--text-muted)', marginBottom: '2px' }}>Wzorce regex</label>
            <input type="text" value={newUnit.wzorce_regex} onChange={(e) => setNewUnit({ ...newUnit, wzorce_regex: e.target.value })}
              style={{ width: '100%', padding: '5px 8px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '12px', height: '28px', fontFamily: 'monospace' }}
              placeholder="kaps|kap|caps" />
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '11px', height: '28px' }}>
            <input type="checkbox" checked={newUnit.aktywny} onChange={(e) => setNewUnit({ ...newUnit, aktywny: e.target.checked })} />
            Aktywna
          </label>
          <button onClick={addUnit}
            style={{ padding: '4px 10px', border: '1px solid var(--success)', color: 'var(--success)', fontSize: '11px', fontWeight: '500', cursor: 'pointer', height: '28px' }}>
            Dodaj
          </button>
        </div>
      </div>

      {/* Lista */}
      <div style={{ backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)', borderRadius: '5px', overflow: 'hidden' }}>
        <div style={{ backgroundColor: 'var(--border)', padding: '0.5rem 0.75rem', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{ fontSize: '1rem' }}>📏</span>
          <h6 style={{ margin: 0, fontSize: '12px', fontWeight: '600' }}>Lista Jednostek Miary ({units.length})</h6>
        </div>
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          {units.length === 0 ? (
            <p style={{ textAlign: 'center', color: 'var(--text-muted)', margin: 0, padding: '1rem', fontSize: '12px' }}>Brak jednostek miary</p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {units.map((unit) => (
                <div key={unit.id} className="units-list-row" style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '0.5rem 0.75rem',
                  backgroundColor: unit.aktywny ? 'var(--card-bg)' : 'var(--warning-light)',
                  borderBottom: '1px solid var(--bg)', fontSize: '12px'
                }}>
                  <div style={{ flex: 1 }}>
                    {editingUnit && editingUnit.id === unit.id ? (
                      <div className="units-edit-row" style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                        <input type="text" value={editingUnit?.nazwa || ''} onChange={(e) => setEditingUnit({ ...editingUnit, nazwa: e.target.value })}
                          style={{ padding: '4px 6px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px', width: '120px' }} placeholder="Nazwa" />
                        <input type="text" value={editingUnit?.skrot || ''} onChange={(e) => setEditingUnit({ ...editingUnit, skrot: e.target.value })}
                          style={{ padding: '4px 6px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px', width: '60px' }} placeholder="Skrót" />
                        <input type="text" value={editingUnit?.wzorce_regex || ''} onChange={(e) => setEditingUnit({ ...editingUnit, wzorce_regex: e.target.value })}
                          style={{ padding: '4px 6px', border: '1px solid var(--border)', borderRadius: '3px', fontSize: '11px', width: '150px', fontFamily: 'monospace' }} placeholder="Wzorce" />
                        <label style={{ display: 'flex', alignItems: 'center', gap: '3px', fontSize: '10px' }}>
                          <input type="checkbox" checked={editingUnit?.aktywny || false} onChange={(e) => setEditingUnit({ ...editingUnit, aktywny: e.target.checked })} />
                          Aktywna
                        </label>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                        <span style={{ fontWeight: '500', color: unit.aktywny ? 'var(--text-secondary)' : 'var(--warning)' }}>{unit.nazwa}</span>
                        <span style={{ fontSize: '10px', backgroundColor: 'var(--border)', padding: '1px 6px', borderRadius: '3px' }}>{unit.skrot}</span>
                        {!unit.aktywny && <span style={{ fontSize: '10px', color: 'var(--warning)' }}>(nieaktywna)</span>}
                        {unit.wzorce_regex && <span style={{ fontSize: '10px', color: 'var(--text-muted)', fontFamily: 'monospace' }}>| {unit.wzorce_regex}</span>}
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', gap: '4px' }}>
                    {editingUnit && editingUnit.id === unit.id ? (
                      <>
                        <button onClick={updateUnit} style={{ padding: '4px 10px', fontSize: '11px', border: '1px solid var(--success)', color: 'var(--success)', cursor: 'pointer' }}>Zapisz</button>
                        <button onClick={cancelEditUnit} style={{ padding: '4px 10px', fontSize: '11px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)', cursor: 'pointer' }}>Anuluj</button>
                      </>
                    ) : (
                      <>
                        <button onClick={() => startEditUnit(unit)} style={{ padding: '4px 10px', fontSize: '11px', border: '1px solid var(--info)', color: 'var(--info)', cursor: 'pointer' }}>Edytuj</button>
                        <button onClick={() => deleteUnit(unit.id)} style={{ padding: '4px 10px', fontSize: '11px', border: '1px solid var(--danger)', color: 'var(--danger)', cursor: 'pointer' }}>Usuń</button>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UnitsTab;
